import React from 'react';
export function TrustBar() {
  return <section className="w-full bg-bg-alt py-5 border-y border-border-light px-4 relative overflow-hidden" data-id="element-205">
      {/* Subtle gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-primary/5 to-transparent" data-id="element-206"></div>

      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-4 text-center relative z-10" data-id="element-207">
        <div className="flex items-center gap-2 text-2xl bg-white/5 px-4 py-2 rounded-full border border-white/10 shadow-inner" data-id="element-208">
          <span data-id="element-209">🇲🇽</span>
          <span data-id="element-210">🇪🇸</span>
          <span data-id="element-211">🇦🇷</span>
          <span data-id="element-212">🇨🇱</span>
          <span data-id="element-213">🇨🇴</span>
          <span data-id="element-214">🇺🇾</span>
          <span data-id="element-215">🇵🇪</span>
        </div>
        <p className="text-text-sec text-sm sm:text-base font-medium" data-id="element-216">
          La Herramienta de FÚTBOL N.1 elegida por más de{' '}
          <span className="font-bold text-primary drop-shadow-[0_0_8px_rgba(59,130,246,0.5)]" data-id="element-217">
            15,000 entrenadores
          </span>{' '}
          en todo el mundo hispanohablante.
        </p>
      </div>
    </section>;
}